export default __webpack_public_path__ + "static/media/group_therapy2.4aec9071.png";